type ScrollIntoViewProps = {
  scrollToElement: (anchorSelector: `#${string}`) => void
}

export const useScrollIntoView = (): ScrollIntoViewProps => {
  const scrollToElement = (anchorSelector: `#${string}`): void => {
    const targetElement = document.querySelector(anchorSelector)

    if (!targetElement) {
      return
    }

    targetElement.scrollIntoView({
      behavior: "smooth",
    })
  }

  return {
    scrollToElement,
  }
}
